import ContentService from 'src/common/api/content.service';

export async function searchContent({ commit }) {
  const response = await ContentService.searchContent();
  if (response.status === 200) {
    commit('setAll', { all: response.data.data });
  }
}

export async function viewContent({ commit }, { id }) {
  const response = await ContentService.viewContent({ id });
  if (response.status === 200) {
    commit('setCurrent', { current: response.data });
  }
}

export async function createContent(context, { data }) {
  await ContentService.createContent({ data });
}

export async function updateContent(context, { id, data }) {
  await ContentService.updateContent({ id, data });
}

export async function deleteContent(context, { id }) {
  await ContentService.deleteContent({ id });
}
